import styled from 'styled-components/native';

import KeyboardAvoidingViewBase from '@src/components/KeyboardAvoidingView';
import { H1 } from '@src/components/Typography';

export const KeyboardAvoidingView = styled(KeyboardAvoidingViewBase)`
  flex: 1;
  justify-content: space-between;
`;

export const Container = styled.View`
  flex-grow: 1;
  justify-content: space-between;
`;

export const Title = styled(H1)`
  margin-vertical: 20px;
`;
